import React, { createContext, ReactElement, useState } from 'react';
import { useSelector } from 'react-redux';
import { BUY, CALL_OPTION, selectors } from 'state';
import { OptionsChainRow } from './OptionsTab/OptionsChain';

type logsContextType = {
  selectedOptionAsset: number | undefined;
  setSelectedOptionAsset: (selectedOptionAsset: number) => void;
  selectedExpirationDate: string | undefined;
  setSelectedExpirationDate: (selectedExpirationDate: string) => void;
  // selectedOptionsContract: OptionsChainRow | undefined;
  // setSelectedOptionsContract: (
  //   selectedOptionsContract: OptionsChainRow
  // ) => void;
  selectedOptionType: number; // Use numeric constant: CALL_OPTION or PUT_OPTION
  setSelectedOptionType: (type: number) => void;

  selectedOptionTransaction: number;
  setSelectedOptionTransaction: (type: number) => void;

  selectedContractsQuantity: number;
  setSelectedContractsQuantity: (type: number) => void;
};

export const TraineeOptionsContext = createContext<logsContextType>({
  selectedOptionAsset: undefined,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setSelectedOptionAsset: () => {},
  selectedExpirationDate: undefined,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setSelectedExpirationDate: () => {},
  // selectedOptionsContract: undefined,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  // setSelectedOptionsContract: () => {},
  selectedOptionType: CALL_OPTION, // default to CALL_OPTION, for example
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setSelectedOptionType: () => {},
  selectedOptionTransaction: BUY,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setSelectedOptionTransaction: () => {},
  selectedContractsQuantity: 0,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setSelectedContractsQuantity: () => {},
});

export function TraineeOptionsContextWrapper(props: {
  children: ReactElement;
}) {
  const [selectedOptionAsset, setSelectedOptionAsset] = useState<
    number | undefined
  >(undefined);
  const [selectedExpirationDate, setSelectedExpirationDate] = useState<
    string | undefined
  >(undefined);
  // const [selectedOptionsContract, setSelectedOptionsContract] = useState<
  //   OptionsChainRow | undefined
  // >(undefined);
  const [selectedOptionType, setSelectedOptionType] =
    useState<number>(CALL_OPTION);
  const [selectedOptionTransaction, setSelectedOptionTransaction] =
    useState<number>(BUY);

  const [selectedContractsQuantity, setSelectedContractsQuantity] =
    useState<number>(100);
  return (
    <TraineeOptionsContext.Provider
      value={{
        selectedOptionAsset: selectedOptionAsset,
        setSelectedOptionAsset: setSelectedOptionAsset,
        selectedExpirationDate: selectedExpirationDate,
        setSelectedExpirationDate: setSelectedExpirationDate,
        // selectedOptionsContract: selectedOptionsContract,
        // setSelectedOptionsContract: setSelectedOptionsContract,
        selectedOptionType: selectedOptionType,
        setSelectedOptionType: setSelectedOptionType,
        selectedOptionTransaction: selectedOptionTransaction,
        setSelectedOptionTransaction: setSelectedOptionTransaction,
        selectedContractsQuantity: selectedContractsQuantity,
        setSelectedContractsQuantity: setSelectedContractsQuantity,
      }}
    >
      {props.children}
    </TraineeOptionsContext.Provider>
  );
}
